import React from 'react';
import { CountryDropdown } from 'react-country-region-selector';
// helpers
import * as G from '../../../../helpers';
//////////////////////////////////////////////////

const CountrySelect = (props) => {
  const { id, value, onChange, setFieldValue, setFieldTouched } = props;

  const handleBlur = () => setFieldTouched(id, true);

  const handleChange = (value) => {
    if (G.isFunction(onChange)) return onChange({ target: { value } });

    return setFieldValue(id, value);
  };

  return (
    <CountryDropdown
      id={id}
      value={value || ''}
      onBlur={handleBlur}
      onChange={handleChange}
    />
  );
};

export default CountrySelect;
